<div class="twc-container twc-m-2">
    <div class="twc-mt-1 twc-mb-3" *ngIf="subtitle">{{subtitle | translate}}</div>

    <div class="twc-row twc-col-12 twc-mb-2">
        <h3 class="twc-h3">{{'SCANPROC.POINT_SELECTOR_TITLE' | translate}}</h3>
    </div>

    <form [formGroup]="service.pointSelectorForm">
        <div class="twc-checkbox twc-mt-2 twc-mb-2">
            <input class="twc-checkbox-input" type="checkbox" id="edit-center-checkbox" formControlName="editCenter"
                (change)="onChangeCenterEdition()">
            <label class="twc-checkbox-label" for="edit-center-checkbox">
                {{'SCANPROC.POINT_SELECTOR_EDIT_CENTER' | translate}}
            </label>
        </div>

        <fieldset [disabled]="!service.pointSelectorForm.get('editCenter')?.value" class="twc-d-flex point-data">
            <legend>{{'SCANPROC.POINT_SELECTOR_EDIT_CENTER' | translate}}</legend>
            <div>
                <label class="twc-form-label">{{'SCANPROC.POINT_SELECTOR_LABEL_X' | translate}}</label>
                <input type="number" class="twc-input" formControlName="x">
            </div>

            <div>
                <label class="twc-form-label">{{'SCANPROC.POINT_SELECTOR_LABEL_Y' | translate}}</label>
                <input type="number" class="twc-input" formControlName="y">
            </div>

            <div>
                <label class="twc-form-label">{{'SCANPROC.POINT_SELECTOR_LABEL_Z' | translate}}</label>
                <input type="number" class="twc-input" formControlName="z">
            </div>
        </fieldset>
    </form>
</div>